// creates a mapping of pathname (eg: "/calls/list") to properties that represent it (eg:
// pathname: /calls/list, title: Calls | List, app: app)
export function createUrlMap(SUBMENU) {
  return _createUrlMap(SUBMENU, {}, [], []);
};

function _createUrlMap(SUBMENU, URL, paths, titles) {
  SUBMENU.forEach((element) => {
    let myPaths = [...paths,element.url];
    let myTitles = [...titles,element.title];
    let fullUrl = '/' + myPaths.join('/');
    let isSelector = element.isSelector;

    if (element.hasOwnProperty('children') && element.children.length > 0) {
      _createUrlMap(element.children, URL, myPaths, myTitles);
    } else {
      URL[fullUrl] = {url: fullUrl, app: element.app, title: element.title, titles: myTitles, isSelector: isSelector};
    }
  });

  return URL;
};

// Check we have all required attributes, and generate the 'fullPath' attribute
export function testAndSet(SUBMENU, STAGE) {
  _testAndSet(SUBMENU, [], STAGE);
};

function _testAndSet (SUBMENU, paths, STAGE) {
  let requiredProperties = ["title","url","icon"];
  let removables = [];

  for (let idx = 0; idx < SUBMENU.length; idx++) {
    let element = SUBMENU[idx];
    if (element.devOnly && STAGE !== "dev") {
      removables.push(idx); 
    } 
    if (!element.hasOwnProperty('app') && !element.hasOwnProperty('children')) {
      console.error("Menu is not properly formatted. Must have either [app] or " + 
          "[children] on object [%O].", element);
      return;
    }
    requiredProperties.forEach((req) => {
      if (!element.hasOwnProperty(req)) {
        console.error("Menu is not properly formatted. [" + req + 
            "] property missing from an object [%O].", element);
        return;
      }
    });

    let myPaths = [...paths, element.url];
    element.fullPath = '/' + myPaths.join('/');

    if (element.hasOwnProperty('children') && element.children.length > 0) {
      _testAndSet(element.children, myPaths, STAGE);
    }
  };

  for (let r_idx = removables.length-1; r_idx >= 0; r_idx--) {
    SUBMENU.splice(removables[r_idx],1);
  }
};

// create a map of urls for Constants ... assume flattenedURLMap is already created
export function createNameMap(SUBMENU) {
  return _createNameMap("",SUBMENU);
};

function _createNameMap(baseStr,SUBMENU) {
  let URL = {};
  SUBMENU.forEach((element) => {
    let key = element.url.toUpperCase();
    let url = baseStr + "/" + element.url;

    if (URL.hasOwnProperty(key) && (!Array.isArray(URL[key]) || element.children.length === 0)) {
      console.err("Found an instance of an exact path as well as a parent path on key [" + 
          key + "]. Eg: /calls is not allowed an app along with /calls/list having an app.")
    }

    if (!element.hasOwnProperty('children') || element.children.length === 0) {
      URL[key] = url;
    } else {
      URL[key] = _createNameMap(url, element.children);
    }
  });

  return URL;
};

export function getUpdatedDate(timePeriodKey) {
  let d = new Date();
  let currentHours = d.getUTCHours();
  d.setUTCMinutes(0);
  d.setUTCSeconds(0);
  d.setUTCMilliseconds(0);
  d.setUTCHours(0);
  switch (timePeriodKey) {
    case 'DAY':
      break;
    case 'HOURS':
      d.setUTCHours(currentHours-24);
      break;
    case 'WEEK':
      d.setUTCDate(d.getUTCDate()-7);
      break;
    default:
    case 'MONTH':
      d.setUTCMonth(d.getUTCMonth()-1);
      break;
    case 'THREEMONTH':
//      d.setUTCMonth(d.getUTCMonth()-3,1);
      d.setUTCMonth(d.getUTCMonth()-3);
      break;
    case 'SIXMONTH':
//      d.setUTCMonth(d.getUTCMonth()-6,1);
      d.setUTCMonth(d.getUTCMonth()-6);
      break;
    case 'YEAR':
//      d.setUTCMonth(d.getUTCMonth()-12,1);
      d.setUTCMonth(d.getUTCMonth()-12);
      break;
  }
  return d;
};
